/*
  XOL-67: the structure-type tree (`getConfig().structures`) as el-cascader reads it. A group node ("Lampole", "QB") has a label and children
  but no value; a leaf has the structure id as its value. el-cascader names a node by the VALUES of its path, so a group stands as `undefined`.
*/

// The path of values from the root to the leaf whose value is `id` (compared as text: a row may carry "11" or 11), or [] when not found / no id.
export function structureValuePath (tree, id) {
  if (id === null || id === undefined || id === '' || !Array.isArray(tree)) {
    return []
  }

  for (var i = 0; i < tree.length; i++) {
    var node = tree[i]

    if (node && Array.isArray(node.children) && node.children.length) {
      var below = structureValuePath(node.children, id)

      if (below.length) {
        return [node.value].concat(below)
      }
    } else if (node && node.value !== undefined && node.value !== null && String(node.value) === String(id)) {
      return [node.value]
    }
  }

  return []
}
